export default __webpack_public_path__ + "static/media/brooklyn_bridge_by_night.d295a6b0.jpg";